export const statusValue: any = {
    'procesando': 'Procesando Cotización',
    'esperando': 'Esperando Confirmación',
    'cotizacionAceptada': 'Cotización Aceptada',
    'preparando': 'Procesando Orden',
    'envio': 'En Proceso de Envío',
    'rechazada': 'Rechazada',
    'finalizada': 'Orden Completada'

}